import type { CSSProperties, ReactElement } from "react";
import type { TraderDef } from "@rietz/shared";
import {
  TRADER_PLACEHOLDER_URL,
  TRADER_PORTRAIT_URLS,
} from "../inventory/itemAtlas.generated.js";

export function traderPortraitUrl(traderId: string): string {
  return TRADER_PORTRAIT_URLS[traderId] ?? TRADER_PLACEHOLDER_URL;
}

export function TraderPortrait(props: {
  trader: TraderDef;
  size: number;
  className?: string;
  style?: CSSProperties;
}): ReactElement {
  return (
    <img
      className={props.className}
      src={traderPortraitUrl(props.trader.id)}
      alt={`${props.trader.name} portrait`}
      width={props.size}
      height={props.size}
      draggable={false}
      style={{
        display: "block",
        width: props.size,
        height: props.size,
        objectFit: "cover",
        objectPosition: "center 22%",
        border: "1px solid rgba(214, 205, 194, 0.28)",
        borderRadius: 3,
        background: "#111315",
        boxShadow: "inset 0 0 18px rgba(0, 0, 0, 0.45)",
        ...props.style,
      }}
    />
  );
}
